export enum Profile {
    DEVELOPMENT = 'development',
    LOCAL = 'local',
    STAGING = 'staging',
    PRODUCTION = 'production',
}

const profile: Profile = (process.env.REACT_APP_PROFILE as Profile) || Profile.DEVELOPMENT;

// load environment variables for the active profile
export const ENV = {
    profile,
    templateBaseUrl: process.env.REACT_APP_TEMPLATE_BASE_URL!,
    baseUrl: process.env.REACT_APP_BASE_URL!,
    otherBaseUrl: process.env.REACT_APP_OTHER_BASE_URL!,
    oidcAuthority: process.env.REACT_APP_OIDC_AUTHORITY!,
    matomoTagManagerUrl: process.env.REACT_APP_MATOMO_TAG_MANAGER_URL!,
    matomoTagManagerUrl2: process.env.REACT_APP_MATOMO_TAG_MANAGER_URL2!,
    internalBaseUrl: process.env.REACT_APP_INTERNAL_BASE_URL!,
    // logistic rides the public gateway; builds without the var fall back to the internal host
    logisticBaseUrl: process.env.REACT_APP_LOGISTIC_BASE_URL || process.env.REACT_APP_INTERNAL_BASE_URL!,
};

const version = process.env.REACT_APP_VERSION;
console.log(`Environment ${profile} / ${version}`, ENV);

export const IS_DEVELOPMENT = ENV.profile === Profile.DEVELOPMENT;
export const IS_LOCAL = ENV.profile === Profile.LOCAL;
export const IS_STAGING = ENV.profile === Profile.STAGING;
export const IS_PRODUCTION = ENV.profile === Profile.PRODUCTION;
